import React from 'react'
import clsx from 'clsx'
import {withStyles, makeStyles} from '@material-ui/core/styles'
import StepConnector from '@material-ui/core/StepConnector'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Check from '@material-ui/icons/Check'
import * as config from './config'

StepsIndicator = (props)->
	{current} = props.formState
	stepperClasses = stepperStyles()
	labelClasses = labelStyles()
	
	<Stepper alternativeLabel classes={stepperClasses} activeStep={config.screenKeys.indexOf(current)-1} connector={<StyledConnector />}>
		<Step><StepLabel classes={labelClasses} StepIconComponent={StepIcon}>{config.steps[config.INDEX_OF_LOOK_AND_FEEL_STEP].title}</StepLabel></Step>
		<Step><StepLabel classes={labelClasses} StepIconComponent={StepIcon}>{config.steps[config.INDEX_OF_DETAILS_STEP].title}</StepLabel></Step>
		<Step><StepLabel classes={labelClasses} StepIconComponent={StepIcon}>{config.steps[config.INDEX_OF_CUSTOMIZE_CARD_STEP].title}</StepLabel></Step>
		<Step><StepLabel classes={labelClasses} StepIconComponent={StepIcon}>{"Confirmation"}</StepLabel></Step>
	</Stepper>

StepIcon = ({active, completed})->
	classes = iconStyles()

	<div className={clsx classes.root, {[classes.active]:active}}>
		{if completed
			<Check className={classes.completed} />
		else
			<div className={classes.circle} />
		}
	</div>


stepperStyles = makeStyles
	root:
		background: 'transparent'
		marginTop: '20px'
		marginBottom: '10px'
		'@media(max-width:700px)':
			padding: '0 24px'
			marginBottom: '0px'

labelStyles = makeStyles
	label:
		marginTop: '9px !important'
		fontFamily: 'din'
		fontSize: '13px'
		'@media(max-width:700px)':
			display: 'none'

iconStyles = makeStyles
	root:
		color: '#d9dde2'
		display: 'flex'
		height: 22
		alignItems: 'center'
	active:
		color: '#fac408'
	circle:
		width: 8
		height: 8
		borderRadius: '50%'
		backgroundColor: 'currentColor'
	completed:
		color: '#fac408'
		zIndex: 1
		fontSize: 18

StyledConnector = withStyles(
	root:
		background: 'transparent'
	alternativeLabel:
		top: 10
		left: 'calc(-50% + 16px)'
		right: 'calc(50% + 16px)'
	active:
		'& $line':
			borderColor: '#fac408'
	completed:
		'& $line':
			borderColor: '#fac408'
	line:
		borderColor: '#d9dde2'
		borderTopWidth: 3
		borderRadius: 1
)(StepConnector)


export default StepsIndicator